import settings from './settings';
import ledgerAccounts from './ledgerAccounts';
import fiscalYears from './fiscalYears';
import postingRules from './postingRules';
import bankAccounts from './bankAccounts';
import journals from './journals';
import entries from './entries';
import taxLines from './taxLines';

// Single `accounting` namespace, composed from one file per concern (settings,
// ledgerAccounts, …). State/getters/mutations/actions are merged flat so getter
// paths stay `accounting/<name>` (e.g. accounting/isActivated) as the section
// grows lot by lot. Keep sub-file key names unique across files.
const submodules = [
  settings,
  ledgerAccounts,
  fiscalYears,
  postingRules,
  bankAccounts,
  journals,
  entries,
  taxLines,
];
const merge = (key) =>
  submodules.reduce((acc, mod) => ({...acc, ...mod[key]}), {});

export default {
  namespaced: true,
  state: merge('state'),
  getters: merge('getters'),
  mutations: merge('mutations'),
  actions: merge('actions'),
};
